import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import logo from "../assets/logo.png";
import {
  MdOutlineAddBusiness,
  MdQrCodeScanner,
  MdDateRange,
  MdSos
} from "react-icons/md";

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const role = await login(email, password);

      if (role === "admin") {
        navigate("/admin");
      } else if (role === "Cobrador") {
        navigate("/cobrador");
      } else {
        // Si no hay roles definidos, o el rol es "user", redirige a un dashboard general
        navigate("/dashboard");
      }
    } catch (err) {
      setError("Credenciales inválidas. Intenta nuevamente.");
    }
  };

  return (
    <div
      className="flex justify-center items-center h-screen"
      style={{ background: "linear-gradient(to top, #751934, white)" }}
    >
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Logo" className="w-20 h-20 object-contain" />
        </div>
        <h2 className="text-3xl font-semibold text-center text-[#083416] mb-6">
          Iniciar Sesión
        </h2>
        {error && <p className="text-red-600 text-center mb-4">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Correo Electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-md p-3 focus:ring focus:ring-green-200 focus:outline-none"
              placeholder="Ingresa tu correo electrónico"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-md p-3 focus:ring focus:ring-green-200 focus:outline-none"
              placeholder="Ingresa tu contraseña"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#751934] hover:bg-custom-gold text-white font-semibold py-3 rounded-md transition duration-200"
          >
            Iniciar Sesión
          </button>
        </form>
      </div>
      <button
  onClick={() => window.open("https://auxsac.igob.mx/", "_blank", "noopener,noreferrer")}
  title="SOS"
  aria-label="SOS"
  className="fixed bottom-5 right-5 z-[110] h-14 w-14 rounded-full shadow-lg bg-red-600 text-white flex items-center justify-center hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-white/60"
>
  <MdSos size={28} />
</button>
    </div>
  );
};

export default LoginPage;
